export const MIN_FLEX_GROW = 0.1;

// Height of a collapsed directory (header only) - must match $directory-header-height in Directory.module.scss
export const DIRECTORY_HEADER_HEIGHT = 48;

export const MIN_RESIZABLE_HEIGHT = 80;
